module.exports = __webpack_public_path__ + "static/media/star_full.f905f8a1.svg";